// import jQuery from 'jquery'
// window.jQuery = jQuery
// window.$ = jQuery
// import 'jquery-ui'
// console.log(['window', window])
